
    export const apiUrl = "https://v2.co4.dev";
    export const oidcUrl = "https://auth.co4.dev/auth/realms/co4_dev";
    export const feedUrl = "https://feed.piral.cloud/api/v1/pilet/co4-dev?tag=newdm";
    export const appEnv = "development";
  